import { nsOrganization } from '@/app/i18n/namespaces';

const ORGANIZATION_TYPES = {
    MERCHANT: { name: 'MERCHANT', entity: 'type.MERCHANT', namespace: nsOrganization },
    WHITE_LABEL: { name: 'WHITE_LABEL', entity: 'type.WHITE_LABEL', namespace: nsOrganization }

};

export default ORGANIZATION_TYPES;